import { render, staticRenderFns } from "./MyTutor.vue?vue&type=template&id=f0a2b306&scoped=true&"
import script from "./MyTutor.vue?vue&type=script&lang=js&"
export * from "./MyTutor.vue?vue&type=script&lang=js&"
import style0 from "./MyTutor.vue?vue&type=style&index=0&id=f0a2b306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2b306",
  null
  
)

export default component.exports